/**
 * RadioField Component
 *
 * radio 타입 필드를 렌더링하는 컴포넌트
 * shadcn/ui RadioGroup 컴포넌트 사용
 */

import { Label } from '@/shared/ui/label';
import { RadioGroup, RadioGroupItem } from '@/shared/ui/radio-group';

import type { BaseFieldProps } from './types';

/**
 * 라디오 버튼 그룹 필드
 */
export function RadioField({ field, value, onChange, disabled, error }: BaseFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <RadioGroup
        value={(value as string) || (field.defaultValue as string)}
        onValueChange={(val) => onChange(val)}
        disabled={disabled}
      >
        {field.options?.map((option) => (
          <div key={option.value} className="flex items-center gap-2">
            <RadioGroupItem value={option.value} id={`${field.id}-${option.value}`} />
            <Label htmlFor={`${field.id}-${option.value}`} className="font-normal">
              {option.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
